import React, { useEffect, useState, useMemo } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import { newCompanyStatus } from "./userStatus";
import {
  admin_applicationss_list,
  admin_messsage_view,
  superadmin_app_list,
  admin_msg_status_change,
  getUserStatuses,
  admin_applications_search,
  super_newcomp_delete,
  admin_domains_list,
  send_bulk_emails,
} from "../admin.api";
import Notification from "./notification/notification";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import Pagination from "../../../components/table/Pagination";
import TextEditer from "../../../components/inputs/texteditor";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useParams } from "react-router-dom";

export default function BulkEmail(props) {
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState("");
  // Domain is not used on this bulk email page; only status search is supported
  const [activeDomain, setActiveDomain] = useState("");
  const [domains, setDomains] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [emailFormData, setEmailFormData] = useState({
    subject: '',
    body_html: '',
    metadata: {
      campaign: '',
      priority: 'normal'
    }
  });
  const premise = useParams().id;

  // Pagination settings (same as CustomTable)
  const PageSize = 10;

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleSelectAll = () => {
    console.log('handleSelectAll called, current selectAll:', selectAll);
    if (selectAll) {
      console.log('Deselecting all');
      setSelectedRows([]);
      setSelectAll(false);
    } else {
      const allIds = data.map(item => item.uuid);
      console.log('Selecting all IDs:', allIds);
      setSelectedRows(allIds);
      setSelectAll(true);
    }
  };

  const handleUnselectAll = () => {
    console.log('handleUnselectAll called');
    setSelectedRows([]);
    setSelectAll(false);
  };

  const handleRowSelect = (uuid) => {
    console.log('handleRowSelect called with uuid:', uuid);
    console.log('Current selectedRows:', selectedRows);
    console.log('Data length:', data.length);

    if (selectedRows.includes(uuid)) {
      const newSelectedRows = selectedRows.filter(id => id !== uuid);
      console.log('Removing uuid, new selectedRows:', newSelectedRows);
      setSelectedRows(newSelectedRows);
      setSelectAll(false);
    } else {
      const newSelectedRows = [...selectedRows, uuid];
      console.log('Adding uuid, new selectedRows:', newSelectedRows);
      setSelectedRows(newSelectedRows);
      if (newSelectedRows.length === data.length) {
        console.log('All items selected, setting selectAll to true');
        setSelectAll(true);
      }
    }
  };

  const getReuestList = () => {
    setIsActive(true);
    if (adminType === 1 || adminType === 23) {
      admin_applicationss_list().then((res) => {
        let filteredArray = [];
        if (premise === "own") {
          filteredArray = res.data.filter(
            (data) => data.area_type === "own_land"
          );
        } else {
          filteredArray = res.data.filter(
            (data) => data.area_type !== "own_land"
          );
        }
        console.log('Data loaded:', filteredArray);
        setData(filteredArray);
        setIsActive(false);
      });
    } else {
      superadmin_app_list().then((res) => {
        let filteredArray = [];
        if (premise === "own") {
          filteredArray = res.data.filter(
            (data) => data.area_type === "own_land"
          );
        } else {
          filteredArray = res.data.filter(
            (data) => data.area_type !== "own_land"
          );
        }
        console.log('Data loaded:', filteredArray);
        setData(filteredArray);
        setIsActive(false);
      });
    }
  };

  const getStatusList = () => {
    setStatuses(newCompanyStatus);
  };

  // Domain list is not needed for this page anymore (status-only search)
  const getUserDomains = () => {
    admin_domains_list().then((res) => {
      setDomains(res.data);
    });
  };

  // Centralized filtered fetch used by status search
  const fetchFilteredRequests = (statusValue) => {
    const statusParam = statusValue ?? "";

    setIsActive(true);
    // Only pass status to the API; domain filter is not used on this page
    admin_applicationss_list(statusParam, "")
      .then((res) => {
        let filteredArray = [];
        if (premise === "own") {
          filteredArray = res.data.filter(
            (item) => item.area_type === "own_land"
          );
        } else {
          filteredArray = res.data.filter(
            (item) => item.area_type !== "own_land"
          );
        }
        setData(filteredArray);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  const handleSearch = () => {
    // Reset to first page when running a new search
    setCurrentPage(1);
    fetchFilteredRequests(activeStatus);
  };

  const manageDomains = (e) => {
    const value = e.target.value;
    setActiveDomain(value);
    // Domain changes are ignored for filtering on this page
  };

  const manageStatus = (e) => {
    const value = e.target.value;
    setActiveStatus(value);
    // Trigger search immediately when status changes
    setCurrentPage(1);
    fetchFilteredRequests(value);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      getReuestList();
    }
  };

  const handleSendEmail = () => {
    const selectedCompanies = data.filter(item => selectedRows.includes(item.uuid));
    const emails = selectedCompanies.map(item => item.email).filter(email => email);

    if (emails.length === 0) {
      setSnackMessage("No valid email addresses found for selected companies");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    // Open email compose popup instead of mailto link
    setShowEmailPopup(true);
  };

  const handleEmailSubmit = async () => {
    const selectedCompanies = data.filter(item => selectedRows.includes(item.uuid));
    const emails = selectedCompanies.map(item => item.email).filter(email => email);

    // Use the actual database ID (not UUID) - assuming it's 'id' field            width: '95%',

    const userIds = selectedCompanies.map(item => item.user_id).filter(user_id => user_id);

    // Create FormData for multipart/form-data with file uploads
    const formData = new FormData();

    // Append all the email data
    formData.append('user_category', 'companies');

    // Append user_ids as array
    userIds.forEach((id) => {
      formData.append('user_ids[]', id);
    });

    formData.append('subject', emailFormData.subject);
    formData.append('body_html', emailFormData.body_html);

    // Append metadata as array fields
    formData.append('metadata[campaign]', emailFormData.metadata.campaign);
    formData.append('metadata[priority]', emailFormData.metadata.priority);

    // Append files as array
    selectedFiles.forEach((file) => {
      formData.append('documents[]', file);
    });

    console.log('Sending email with FormData:', formData);

    try {
      setIsActive(true);
      // Call the bulk email API with FormData
      const response = await send_bulk_emails(formData);

      setSnackMessage(`Email sent to ${emails.length} companies successfully!`);
      setIsSnackError(false);
      setSnackOpen(true);
      setShowEmailPopup(false);

      // Uncheck all rows after successful email send
      setSelectedRows([]);
      setSelectAll(false);

      // Reset form and files
      setEmailFormData({
        subject: '',
        body_html: '',
        metadata: {
          campaign: '',
          priority: 'normal'
        }
      });
      setSelectedFiles([]);
    } catch (error) {
      console.error('Error sending bulk email:', error);
      setSnackMessage(error.message || 'Failed to send emails. Please try again.');
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  const handleEmailCancel = () => {
    setShowEmailPopup(false);
    // Reset form and files
    setEmailFormData({
      subject: '',
      body_html: '',
      body_text: '',
      metadata: {
        campaign: '',
        priority: 'normal'
      }
    });
    setSelectedFiles([]);
  };

  const handleEmailFormChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setEmailFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setEmailFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    getReuestList();
  }, []);

  useEffect(() => {
    getStatusList();
  }, []);

  useEffect(() => {
    getUserDomains();
  }, []);

  // Custom table component with pagination (same pattern as CustomTable)
  const CustomTableWithCheckbox = ({ data, columns }) => {
    // Pagination logic (same as CustomTable)
    const currentTableData = useMemo(() => {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return data?.slice(firstPageIndex, lastPageIndex);
    }, [data, currentPage]);

    return (
      <>
        <div className="table-responsive">
          <table className="table-bordered" style={{ width: '100%' }}>
            <thead className="thead-white thed">
              <tr>
                {columns.map((item, index) => (
                  <td
                    key={index}
                    className={
                      item.type === "status"
                        ? "statuscoloum"
                        : item.type === "notification"
                          ? "messagecoloum"
                          : item.type === "dynId"
                            ? "noFieldTableWidth"
                            : ""
                    }
                    style={{ color: "white", backgroundColor: "#666" }}
                  >
                    {item.title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody style={{ borderRight: "1px solid black" }}>
              {currentTableData && currentTableData.length > 0 ? (
                currentTableData.map((item, index) => (
                  <tr key={index}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex}>
                        {column.field === "select" ? (
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item.uuid)}
                            onChange={(e) => {
                              e.stopPropagation();
                              console.log('Checkbox clicked for:', item.uuid, 'Checked:', e.target.checked);
                              handleRowSelect(item.uuid);
                            }}
                            style={{ cursor: 'pointer' }}
                          />
                        ) : column.type === "fullDate" ? (
                          item[column.field]
                            ? moment(item[column.field]).format("DD-MM-YYYY")
                            : ""
                        ) : column.type === "notification" ? (
                          <div
                            className="notificationContainer"
                            onClick={(e) => {
                              if (props.handleNotification) {
                                props.handleNotification(item);
                              }
                            }}
                          >
                            <span className={item[column.field] === 1 ? "activenoti" : "notificationItem"}>
                              🔔
                            </span>
                          </div>
                        ) : column.type === "regstatusType" ? (
                          <div className={getStatusClass(parseInt(item[column.field]))}>
                            {getStatusTitle(parseInt(item[column.field]))}
                          </div>
                        ) : (
                          item[column.field] || ""
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    style={{ textAlign: "center" }}
                    colSpan={columns.length}
                  >
                    No Records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination - Same as CustomTable */}
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={data.length}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </>
    );
  };

  const getStatusClass = (status) => {
    const statusClasses = {
      0: "pending",             // Pending
      1: "inprogress",          // Submitted
      2: "Accepted",            // Accepted
      3: "inprogress",          // SA Reverted
      4: "rejected",            // Rejected
      5: "inprogress",          // Reverted
      6: "agrementexecution",   // Agreement Execution
      7: "Accepted",            // Ongoing Project
      8: "Completed",           // Completed
      15: "Suggestion",         // Suggestion
      16: "Waiting",            // Waiting
    };
    return statusClasses[status] || "";
  };

  const getStatusTitle = (status) => {
    const statusTitles = {
      0: "Pending",
      1: "Submitted",
      2: "Accepted",
      3: "SA Reverted",
      4: "Rejected",
      5: "Reverted",
      6: "Agreement Execution",
      7: "Ongoing Project",
      8: "Completed",
      15: "Suggestion",
      16: "Waiting",
    };
    return statusTitles[status] || "";
  };

  let tableColumns = [
    { title: "Select", field: "select" },
    { title: "Company Name", field: "company_name" },
    { title: "Application ID", field: "unique_application_ref_no" },
    { title: "Email", field: "email" },
    { title: "Created at", field: "created_at", type: "fullDate" },
    ...(adminType === 2 ? [{
      title: "Messages",
      field: "to_super_admin_read_status",
      type: "notification",
    }] : []),
    {
      title: "Application Status",
      field: "application_status",
      type: "regstatusType",
    },
  ];

  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <Loader open={isActive} />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>
              {premise !== "own"
                ? "Bulk Email - Companies in KSPACE Premises"
                : "Bulk Email - Companies in KSPACE - Own-Premises"}
            </b>
          </h6>
          <div className="d-flex gap-2">
            <button
              className="px-2 py-2 btn btn-primary rounded"
              onClick={handleSelectAll}
            >
              Select All
            </button>
            {selectedRows.length > 0 && (
              <button
                className="px-2 py-2 btn btn-secondary rounded"
                onClick={handleUnselectAll}
              >
                Unselect All
              </button>
            )}
            {selectedRows.length > 0 && (
              <button
                className="px-2 py-2 search-style border-0 text-white rounded"
                onClick={handleSendEmail}
              >
                Send Email ({selectedRows.length})
              </button>
            )}
          </div>
        </div>
        <hr />

        <div className="row font-z">
          <div className="col-3">
            <select
              className="form-select"
              aria-label="Default select example"
              onChange={(e) => manageStatus(e)}
            >
              <option value={""}>Select Status</option>
              {statuses.map((item) => (
                <option
                  key={item.user_status_code}
                  value={item.user_status_code}
                >
                  {item.user_status_title}
                </option>
              ))}
              <option value={7}>Ongoing Projects</option>
              <option value={6}>Agreement Execution</option>
            </select>
          </div>
          <div className="col-1 d-flex">
            <SearchButton {...props} onClick={handleSearch} />
          </div>
        </div>

        <div className="mb-3">
          <small className="text-muted">
            {selectedRows.length} of {data.length} companies selected
          </small>
        </div>

        <CustomTableWithCheckbox
          data={data}
          columns={tableColumns}
          handleNotification={props.handleNotification}
        />
      </div>

      {/* Email Compose Popup */}
      {showEmailPopup && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            paddingLeft: '20px',
            borderRadius: '8px',
            width: '100%',
            maxWidth: '900px',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h5 className="modal-title">Compose Email</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleEmailCancel}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '24px',
                  cursor: 'pointer',
                  marginBottom: '10px',
                  fontWeight: 'semibold',
                  opacity: 1,          
                  filter: 'none' 
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">To: {selectedRows.length} companies selected</label>
              </div>

              <div className="mb-3">
                <label className="form-label">Subject *</label>
                <input
                  type="text"
                  className="form-control"
                  value={emailFormData.subject}
                  onChange={(e) => handleEmailFormChange('subject', e.target.value)}
                  placeholder="Enter email subject"
                />
              </div>

              <div className="mb-3">
                <TextEditer
                  label="Message (HTML) *"
                  value={emailFormData.body_html}
                  onChange={(value) => handleEmailFormChange('body_html', value)}
                  required={true}
                />
              </div>


              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Campaign</label>
                  <input
                    type="text"
                    className="form-control"
                    value={emailFormData.metadata.campaign}
                    onChange={(e) => handleEmailFormChange('metadata.campaign', e.target.value)}
                    placeholder="Campaign name"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Priority</label>
                  <select
                    className="form-select"
                    value={emailFormData.metadata.priority}
                    onChange={(e) => handleEmailFormChange('metadata.priority', e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="high">High</option>
                    <option value="low">Low</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Attachments</label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={handleFileChange}
                />
                {selectedFiles.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">Selected files:</small>
                    {selectedFiles.map((file, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-center mt-1">
                        <small className="text-primary">{file.name} ({(file.size / 1024).toFixed(2)} KB)</small>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer" style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '20px'
            }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleEmailCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleEmailSubmit}
                disabled={!emailFormData.subject || !emailFormData.body_html}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
